// extracted by mini-css-extract-plugin
export default {"text-input":"BDzzAXF","text-input__element":"e7JeB7y","text-input__label":"eSnr51p","text-input__icon":"pj47VqV","text-input__input-message":"vOI7qAr","text-input--error":"XCFWGDN"};